var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notoken"},[_vm._v("一共为您找到"),_c('span',{staticClass:"quality"},[_vm._v(_vm._s(_vm.mount))]),_vm._v("条数据，请"),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.tologin}},[_vm._v("登录")]),_vm._v("后查看")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }